import { Program, ProgramListItem } from "../admin/types";

// The public NVFO API (nvfo-api), not the legacy nvre-tenant endpoint above —
// same env var the admin panel and leads/assessment APIs already use.
const NVFO_API_ENDPOINT =
  process.env.REACT_APP_NVFO_API_ENDPOINT || "http://localhost:4000/api/v1";

export async function listPublishedPrograms(): Promise<ProgramListItem[]> {
  const res = await fetch(`${NVFO_API_ENDPOINT}/programs`);
  if (!res.ok) throw new Error("failed to load programs");
  const body = await res.json();
  return body.data.programs as ProgramListItem[];
}

export async function getPublishedProgramBySlug(slug: string): Promise<Program> {
  const res = await fetch(`${NVFO_API_ENDPOINT}/programs/${encodeURIComponent(slug)}`);
  if (res.status === 404) throw new Error("not found");
  if (!res.ok) throw new Error("failed to load program");
  const body = await res.json();
  return body.data.program as Program;
}

export async function getProgramPdfUrl(slug: string): Promise<string> {
  const res = await fetch(`${NVFO_API_ENDPOINT}/programs/${encodeURIComponent(slug)}/pdf`);
  if (!res.ok) throw new Error("failed to generate PDF");
  const body = await res.json();
  return body.data.url as string;
}
